import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import { EVMConnector } from "../connectors/evm";
import { SolanaConnector } from "../connectors/solana";
import { TONConnector } from "../connectors/ton";
import { saveConnection, getStoredConnection, clearConnection } from "../utils/storage";
import { WalletContext } from "./context";
const initialState = {
    address: null,
    chainType: null,
    isConnected: false,
    isConnecting: false,
    error: null
};
export const WalletProvider = (param)=>{
    let { children } = param;
    const [walletState, setWalletState] = useState(initialState);
    const [isInitialized, setIsInitialized] = useState(false);
    const getConnector = (chain)=>{
        switch(chain){
            case "eth":
                return new EVMConnector("eth");
            case "base":
                return new EVMConnector("base");
            case "sol":
                return new SolanaConnector();
            case "ton":
                return new TONConnector();
            default:
                throw new Error("Unsupported chain");
        }
    };
    const connect = async (chain)=>{
        try {
            // 使用单个 setwalletState 调用设置所有状态
            // setWalletState({
            //   ...initialState,
            //   isConnecting: true,
            // });
            const connector = getConnector(chain);
            const address = await connector.connect();
            // 一次性更新所有状态
            setWalletState({
                address,
                chainType: chain,
                isConnected: true,
                isConnecting: false,
                error: null
            });
            saveConnection(address, chain);
        } catch (error) {
            setWalletState({
                ...initialState,
                error
            });
            throw error;
        }
    };
    const disconnect = async ()=>{
        try {
            if (walletState.chainType) {
                const connector = getConnector(walletState.chainType);
                await connector.disconnect();
            }
            setWalletState(initialState);
            clearConnection();
        } catch (error) {
            console.error("Disconnect error:", error);
            // 即使出错也清除状态
            setWalletState(initialState);
            clearConnection();
        }
    };
    const switchChain = async (chain)=>{
        const connector = getConnector(chain);
        await connector.switchNetwork();
    };
    const sendTransaction = async (chain, transaction)=>{
        const connector = getConnector(chain);
        const signature = await connector.sendTransaction(transaction);
        return signature;
    };
    // 初始化钱包状态
    useEffect(()=>{
        const initWallet = async ()=>{
            try {
                const stored = getStoredConnection();
                if (stored) {
                    await connect(stored.chainType);
                }
            } catch (error) {
                console.error("Wallet initialization error:", error);
                // 初始化失败时清除存储的连接信息
                clearConnection();
            } finally{
                setIsInitialized(true);
            }
        };
        initWallet();
    }, []);
    // 使用 useCallback 优化函数
    const handleConnect = useCallback(async (chain)=>{
        await connect(chain);
    }, []);
    const handleDisconnect = useCallback(async ()=>{
        await disconnect();
    }, []);
    const handleSwitchChain = useCallback(async (chain)=>{
        await switchChain(chain);
    }, []);
    const handleSendTransaction = useCallback(async (chain, transaction)=>{
        return await sendTransaction(chain, transaction);
    }, []);
    // const value = useMemo<WalletContextType>(() => (), [JSON.stringify(state),handleConnect, handleDisconnect, handleSwitchChain]);
    // 在初始化完成前显示加载状态
    if (!isInitialized) {
        return null; // 或者返回一个加载指示器
    }
    return /*#__PURE__*/ _jsx(WalletContext.Provider, {
        value: {
            ...walletState,
            connect: handleConnect,
            disconnect: handleDisconnect,
            switchChain: handleSwitchChain,
            sendTransaction: handleSendTransaction
        },
        children: children
    });
};
